import { permissionsOf, type StaffPermission } from "@townsy/contracts";
import { useBootstrapQuery, useMeQuery } from "../../api/queries";

export type StaffAccess = "loading" | "guest" | "none" | "staff";

/**
 * Whether to show staff links (the account menu's "Staff tools", the page header's Admin and Review). Roles come from
 * the account's own `GET /me`; the permissions are the shared matrix applied to them. This only hides UI: every staff
 * route checks its permission on the server, and a forged role here gets nothing from it.
 */
export function useStaffAccess(): { access: StaffAccess; roles: string[]; permissions: StaffPermission[] } {
  const boot = useBootstrapQuery();
  const signedIn = Boolean(boot.data?.session.userId);
  const me = useMeQuery(signedIn);
  const roles = [...new Set([...(boot.data?.session.roles ?? []), ...(me.data?.roles ?? [])])];
  const permissions = permissionsOf(roles);
  if (boot.isPending) return { access: "loading", roles, permissions };
  if (!signedIn) return { access: "guest", roles, permissions };
  if (permissions.length) return { access: "staff", roles, permissions };
  if (me.isPending) return { access: "loading", roles, permissions };
  return { access: "none", roles, permissions };
}
